import {on} from "../jsbase/events";

var BootstrapMenu = require('bootstrap-menu');

export default {
    args: 'target',
    selector: null,
    menu: null,

    props: {
        target: String,
        selector: String,
    },

    data: {
    },

    connect() {
        this.menu = new BootstrapMenu(`#${this.el.getAttribute('id')} ${this.selector}`, {
            fetchElementData: function($rowElem) {
                var rowId = $rowElem.data('id');
                return { id: rowId, positionNumberId: $rowElem.data('posid'), el: $rowElem };
            },
            actions: [{
                name: 'öffnen',
                classNames: 'dropdown-item',
                iconClass: 'bi-eye',
                onClick: this.onOpenPosition,
                isEnabled: (row) => row.el.is('[data-context-slidein]'),
            }, {
                name: 'Position umbenennen',
                classNames: 'dropdown-item',
                iconClass: 'bi-pencil-square',
                onClick: this.onRenamePosition,
                isShow: (row) => row.el.is('[data-context-slidein]'),
            }, {
                name: 'Preise nachschlagen',
                classNames: 'dropdown-item',
                iconClass: 'bi-search',
                onClick: this.onFindPrices,
                isShow: (row) => row.el.is('[data-context-slidein]'),
            }],
        });
        $(this.el).on('onLoaded', this.refreshContextButtons);
    },

    methods: {
        refreshContextButtons(ev) {
            $(ev.currentTarget).find('.btn-context-click').get().forEach((el) => {
                on(el, 'click', (cev) => {
                    cev.preventDefault();
                    cev.stopPropagation();
                    var rowEl = $(cev.target).closest(this.selector);
                    this.menu.open(rowEl, cev);
                    return false;
                });
            });
        },
        onOpenPosition(row) {
            if (row.id) {
                slidein.openUrl(row.el.attr('data-context-slidein'));
            }
        },
        onFindPrices(row) {
            if (row.id) {
                slidein.openUrl('/Preise/ListSlideIn?basePositionId=' + row.positionNumberId);
            }
        },
        onRenamePosition(row) {
            if (row.id) {
                debugger;
                var nameEl = row.el.find('.positionname-' + row.positionNumberId);
                var estimationId = row.el.closest('[data-estimationid]').attr('data-estimationid');
                BootstrapDialog.show({
                    type: BootstrapDialog.TYPE_LIGHT,
                    title: 'Position umbenennen',
                    closable:true,
                    message: function (dialog) {
                        return $('<div class="form-group">' +
                            '  <label>Neuer Positions-Name</label>' +
                            '  <input type="text" class="form-control" name="PositionName" value="'+nameEl.val()+'" />' +
                            '</div>');
                    },
                    buttons: [{
                        label: 'Ja',
                        cssClass: 'btn-success',
                        hotkey: 13, // Enter.
                        action: function (dialog) {
                            var newName = dialog.$modalBody.find('[name="PositionName"]').val();
                            connection.getJson('/ProjectEstimation/SavePositionInfo', {
                                data: {
                                    estimationId: estimationId,
                                    id: row.positionNumberId,
                                    data: {
                                        name: newName,
                                    },
                                },
                                onSuccess: function(data) {
                                    nameEl.val(newName);
                                    dialog.close();
                                },
                                onError: function(response) {
                                    connection.addFormErrors(dialog.$modalBody, response);
                                }
                            });
                        }
                    }, {
                        label: 'Abbrechen',
                        cssClass: 'btn-danger',
                        hotkey: 27, // Esc.
                        action: function (dialog) {
                            dialog.close();
                        }
                    }]
                });
            }
        },
    },

}
